export function getOSVersion() {
  let ua: string;
  
  // Клиентская сторона
  if (import.meta.client) {
    ua = navigator.userAgent;
  } else {
    // Серверная сторона - пытаемся получить User Agent из заголовков
    try {
      const headers = useRequestHeaders();
      ua = headers['user-agent'] || '';
    } catch (error) {
      // Если useRequestHeaders недоступен (вызов вне Nuxt context)
      console.warn('getOSVersion(): useRequestHeaders not available, falling back to Unknown OS');
      return 'Unknown OS';
    }
    
    if (!ua) {
      console.warn('getOSVersion(): User Agent not found in request headers');
      return 'Unknown OS';
    }
  }

  if (ua.includes('Windows NT')) {
    const version = ua.match(/Windows NT (\d+\.\d+)/)
    if (version) {
      return `Windows ${version[1]}`
    }
  } else if (ua.includes('Mac OS X')) {
    const version = ua.match(/Mac OS X (\d+[_.\d]+)/)
    if (version) {
      return `Mac OS ${version[1].replace(/_/g, '.')}`
    }
  } else if (ua.includes('Android')) {
    const version = ua.match(/Android (\d+(\.\d+)?)/)
    if (version) {
      return `Android ${version[1]}`
    }
  } else if (ua.includes('iPhone') || ua.includes('iPad')) {
    const version = ua.match(/OS (\d+_\d+)/)
    if (version) {
      return `iOS ${version[1].replace(/_/g, '.')}`
    }
  }
  
  return 'Unknown OS'
}
